import React from "react";
import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
} from "@mui/material";
import { EnhancedTablePropsClips } from "./ClipsUtilities/clipsInterfaces";
import { visuallyHidden } from "@mui/utils";
import { AlertData, HeadCell } from "../Alerts/AlertsUtils/alertsInterfaces";
import { useClipsStore } from "./ClipsStore/clipsStore";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const headCells: readonly HeadCell[] = [
  {
    id: "site",
    numeric: false,
    label: "Site",
  },
  {
    id: "camera_name",
    numeric: false,
    label: "Camera Name",
  },
  {
    id: "timestamp_received",
    numeric: true,
    label: "Received (UTC)",
  },
  {
    id: "local_time_received",
    numeric: true,
    label: `Received (Local)`,
  },
  // {
  //   id: "clip_result",
  //   numeric: false,
  //   label: "Clip Result",
  // },
  {
    id: "clip_id",
    numeric: true,
    label: "Clip ID",
  },
  {
    id: "armed",
    numeric: false,
    label: "Armed",
  },
];

export const EnhancedSMTPTableHead = (props: EnhancedTablePropsClips) => {
  const { onRequestSort, orderBy, order } = props;
  const createSortHandler =
    (property: keyof AlertData) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };
  const { siteTimeZoneSMTP } = useClipsStore();
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
            // style={{
            //   width: "20%",
            // }}
            sx={{
              fontFamily: "mulish",
              fontWeight: 700,
              fontSize: 10,
              whiteSpace: "nowrap",
            }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              &nbsp;
              {headCell.id === "local_time_received" && siteTimeZoneSMTP && (
                <Tooltip
                  title={`${siteTimeZoneSMTP}`}
                  placement="top"
                  sx={{ fontSize: "10px", fontFamily: "mulish" }}
                >
                  <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                </Tooltip>
              )}
              {headCell.id === "armed" && (
                <Tooltip
                  title={`Clips files are not stored and displayed when the site is not armed.`}
                  placement="top"
                  sx={{ fontSize: "10px", fontFamily: "mulish" }}
                >
                  <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                </Tooltip>
              )}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
